export * from './highlightJs.module';
export * from './highlightJs.token';


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.ts